import Api from '@/services/methods';

const productosComService = {
  async importProductos(productos) {
    try {
      const response = await Api.post('productosCom/import', productos);
      return response.data;
    } catch (error) {
      return { error: true, message: error.response.data.message };
    }
  }
};

export default productosComService;
